(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["language-switcher"] && !Shopify.designMode) return;
  try {
    const items = document.querySelectorAll(".lang-dropdown li");
  items.forEach(item => {
  item.addEventListener("click", function () {
    const code = this.dataset.lang;

    document.getElementById("locale-input").value = code;
    document.getElementById("localization_form").submit();
  });
});

  const switcher = document.querySelector(".header__desktop-language-switcher");
  const dropdown = switcher.querySelector(".lang-dropdown");

  switcher.addEventListener("mouseenter", () => {
    const rect = switcher.getBoundingClientRect();
    // dropdown.style.top = rect.bottom + "px";
    dropdown.style.left = rect.left + "px";
    dropdown.classList.add("active");
});

  switcher.addEventListener("mouseleave", () => {
    dropdown.classList.remove("active");
});
  } catch(e) { console.error(e); }
})();

})();
